import { render, staticRenderFns } from "./Liver.vue?vue&type=template&id=2e2dc18e&"
import script from "./Liver.vue?vue&type=script&lang=ts&"
export * from "./Liver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports